"use strict";
/* LANG */
Object.defineProperty(exports, "__esModule", { value: true });
var Lang = {
    round: function (number) {
        return Math.round(number * 10000000000) / 10000000000;
    }
};
/* EXPORT */
exports.default = Lang;



//////////////////
// WEBPACK FOOTER
// ./~/khroma/dist/utils/lang.js
// module id = 2124
// module chunks = 0